import { useState } from 'preact/hooks';
import { T } from '../styles/tokens';
import { Button } from './ui';

interface AccessScopeItem {
  scope: string;
  description: string;
  risk: 'green' | 'yellow' | 'red';
}

const SCOPES: AccessScopeItem[] = [
  { scope: 'workspace', description: 'Acessar workspace (arquivos, estrutura)', risk: 'green' },
  { scope: 'docs', description: 'Acessar documentação', risk: 'green' },
  { scope: 'memory', description: 'Acessar memória (histórico, decisões)', risk: 'green' },
  { scope: 'config', description: 'Acessar configurações', risk: 'yellow' },
  { scope: 'scripts', description: 'Executar scripts', risk: 'yellow' },
  { scope: 'agents', description: 'Gerenciar agentes IA', risk: 'yellow' },
  { scope: 'tools', description: 'Usar ferramentas (curl, exec, etc)', risk: 'red' },
  { scope: 'identity', description: 'Acessar identidade do usuário', risk: 'red' },
];

interface AccessScopeSelectorProps {
  initialScopes?: string[];
  onScopesChange?: (scopes: string[]) => void;
}

export function AccessScopeSelector({ initialScopes = [], onScopesChange }: AccessScopeSelectorProps) {
  const [selected, setSelected] = useState(new Set(initialScopes));
  const [expanded, setExpanded] = useState(false);

  const toggle = (scope: string) => {
    const newSet = new Set(selected);
    if (newSet.has(scope)) {
      newSet.delete(scope);
    } else {
      newSet.add(scope);
    }
    setSelected(newSet);
    onScopesChange?.(Array.from(newSet));
  };

 const riskIcon = (r: string) => r === 'red' ? '' : r === 'yellow' ? '' : '';

  return (
    <div style={{ marginTop: 20, padding: 16, border: '1px solid #ddd', borderRadius: 8, background: '#f9f9f9' }}>
      <Button variant="ghost"
        onClick={() => setExpanded(!expanded)}
        style={{
          width: '100%',
          textAlign: 'left',
          padding: '12px',
          background: '#fff',
          border: '1px solid #ddd',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 500,
        }}
      >
 {selected.size} permissão(ões) {expanded ? '▼' : ''}
      </Button>

      {expanded && (
        <div style={{ marginTop: 12, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {SCOPES.map((s) => (
            <label
              key={s.scope}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: 10,
                background: '#fff',
                border: selected.has(s.scope) ? '2px solid #0066ff' : '1px solid #ddd',
                borderRadius: 6,
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={selected.has(s.scope)}
                onChange={() => toggle(s.scope)}
                style={{ cursor: 'pointer' }}
              />
              <div style={{ flex: 1, fontSize: 13 }}>
                <div style={{ fontWeight: 500 }}>
                  {riskIcon(s.risk)} {s.scope}
                </div>
                <div style={{ color: T.textMuted, fontSize: 12 }}>{s.description}</div>
              </div>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
